import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class ContrasenhaValidation extends DefaultValidation {
	validate(model, refs) {
		let validated = true;

		if (Util.isNull(model.senha)) {
			refs.senhaInput.focusedOut = true;
			validated = false;
		}

		return validated;
	}
}